const TipStyle = {
    tipsBox: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        height: '18.75rem',
        position: 'relative',
    },

};
export  default TipStyle
